import { Component, Input, OnInit } from '@angular/core';
import { LoaderService } from '../../../core/services/loader.service';
import { SignalrPaymentStatusService } from '../../../apis/signalr-payment-status.service';
import { PaymentRequestStatus } from '../../../types/payment/payment-request-status';

@Component({
  selector: 'app-payment-request-status',
  templateUrl: './payment-request-status.component.html',
  standalone: true,
  styleUrl: './payment-request-status.component.less'
})
export class PaymentRequestStatusComponent implements OnInit {
  @Input()
  paymentRequestStatus: string | undefined;
  statusDescription: string | undefined;

  constructor(
    private loader: LoaderService,
    private notification: SignalrPaymentStatusService
  ) {}

  ngOnInit() {
    //it's the final state of the payment request flow, no need in further notifications
    this.notification.disconnect();
    switch (this.paymentRequestStatus) {
      case PaymentRequestStatus.expired:
        this.statusDescription = 'Het betaalverzoek is niet meer geldig.';
        break;
      case PaymentRequestStatus.cancelled:
        this.statusDescription = 'Het betaalverzoek is geannuleerd.';
        break;
      default:
        this.statusDescription = 'Het betaalverzoek accepteert geen betalingen meer.';
    }
    setTimeout(() => {
      this.loader.hideLoader();
    });
  }
}
